import React from 'react'
import PropTypes from 'prop-types'
import Footer from './footer'
import Header from './header'
import Alert from './alert'
import 'w3-css/w3.css'
import './styles/w3.css'
import './styles/global.css'

export default function Layout({ children }) {
  return (
    <>
      <Alert/>
      <Header />
      <div className="w3-row">{children}</div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
